import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  z-index: 999;

  > div {
    height: 100%;
  }
`;

export const TabWithAutoComplete = styled.div`
  display: grid;
  grid-template-rows: min-content auto;
  grid-template-columns: 1fr;
  width: 100%;
  height: 100%;

  .auto-complete-container {
    display: grid;
    place-items: center;
    width: 100%;
    height: fit-content;
    padding: 2rem;
  }
`